import logo from "./logo.svg";
import "./App.css";
import Home from "./Pages/Home/Home";

function App() {
  return (
    <div>
      <Home></Home>
    </div>
  );
}

export default App;
